export default __webpack_public_path__ + "static/media/Venkateswara.5c4398cf.png";